import { useContext, useRef } from 'react'
import WorkplaceQuizContext from './context/WorkplaceQuizContext'
import WorkplaceQuizRow from './WorkplaceQuizRow'
import WorkplaceQuizModuleMenu from './WorkplaceQuizModuleMenu'
import './WorkplaceBasics.css'
import { onKeyPressHandler } from '../../utilities/commonFunctions'
import { createMarkupWithOption } from '../../models/Common'
import React from 'react'

export interface IWorkplaceQuizesProps {
  isOpen: boolean
  startQuiz: (id: number) => void
  viewResult: () => void
  menuToggled: () => void
}

const WorkplaceQuizes = (props: IWorkplaceQuizesProps) => {
  const context = useContext(WorkplaceQuizContext)
  const inputRef = useRef(null)
  return (
    <>
      <div className="contentAll open">
        <input hidden ref={inputRef} />
        <div className="menu">
          {/* TOP BAR */}
          <div className="barHeaderIntro">
            <div
              className="quickMenuArea"
              onClick={props.menuToggled}
              role="button"
              tabIndex={0}
              onKeyUp={(event) => {
                if (event?.keyCode == '13') {
                  props.menuToggled()
                  inputRef?.current.focus()
                }
              }}
            >
              <a className="quickMenu">
                <img
                  alt="Quick Menu"
                  src="/public/workplace/assets/images/button/clear/quickmenu_normal.png"
                />
                <span>Quick Menu - show/hide above.</span>
              </a>
            </div>
            <WorkplaceQuizModuleMenu
              isOpen={props.isOpen}
              startQuiz={props.startQuiz}
              viewResult={props.viewResult}
            />
            <div className="title">
              <h2 className="titleContent">
                Workplace <span>Basics</span>
              </h2>
            </div>
          </div>
          {/* TOP BAR */}
          {/* MODULES */}
          <div className="modules">
            <div className="introText">
              <h2>
                <span>{context.currentState?.header}</span>
              </h2>
              <div
                className="introBody"
                dangerouslySetInnerHTML={createMarkupWithOption(
                  context.currentState?.body,
                  { ADD_ATTR: ['target'] }
                )}
              ></div>
            </div>
            <div style={{ display: 'block' }}>
              <ul role="tablist">
                {context.currentState?.quizStatus.map((item, index) => {
                  return (
                    <WorkplaceQuizRow
                      key={index}
                      title={item.title}
                      id={item.quizId}
                      completed={item.completed}
                      startQuiz={props.startQuiz}
                    />
                  )
                })}

                <li
                  className="resource"
                  role="tab"
                  onKeyPress={onKeyPressHandler}
                  onClick={() => props.viewResult()}
                  tabIndex={0}
                >
                  <a className="resource button">
                    <div className="resource">
                      <span>Results and resources</span>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WorkplaceQuizes
